<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="排序">
          <a-input placeholder="值越小越靠前" v-decorator="[ 'sort', validatorRules.sort]"/>
        </a-form-item>



        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="类型">

          <a-input placeholder="类型" v-decorator="[ 'type', validatorRules.sort]"/>
        </a-form-item>

         <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="配置名">
          <a-input placeholder="请输入配置名" v-decorator="[ 'name', validatorRules.name]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="配置内容">
          <a-input placeholder="请输入配置内容" v-decorator="[ 'value', validatorRules.value]"/>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import {addProductConfig,editProductConfig } from '@/webpublicapi/operation'
import DictRadioGroup from '../../modules/DictRadioGroup';
export default {
  name: 'DictRadioGroup',
  components:{
    DictRadioGroup
  },
  data () {
    return {
      title: '操作',
      visible: false,
      visibleCheck: true,
      model: {},
      id: '',
      status: 1,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
    validatorRules: {
        sort: { rules: [{ required: true, message: '请输入排序!' }] },
        type: { rules: [{ required: true, message: '请输入类型!' }] },
        name: { rules: [{ required: true, message: '请输入配置名!' }] },
        value: { rules: [{ required: true, message: '请输入配置内容!' }] },
      }
    }
  },
  created () {
  },
  methods: {
    add (dictId) {
      this.dictId = dictId
      this.edit({})
    },
    edit (record) {
      if (record.id) {
          console.log(record)
        this.id = record.id
        this.visibleCheck = (record.status == 1)
      }
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.model.dictId = this.dictId
      this.model.status = this.status
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'name','sort', 'value', 'type'))
      })
    },
    onChose (checked) {
      if (checked) {
        this.status = 1
        this.visibleCheck = true
      } else {
        this.status = 0
        this.visibleCheck = false
      }
    },
    // 确定
    handleOk () {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {

          const formData = Object.assign(this.model, values)
          formData.status = this.status
          let obj
          if (!this.model.id) {
            obj = editProductConfig(formData)
          } else {
            obj = editProductConfig(formData)
          }
          obj.then((res) => {
            if (res.code === 1000) {
              that.$message.success(res.msg)
              that.$emit('ok')
            } else {
              that.$message.warning(res.msg)
            }
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        }
      })
    },
    // 关闭
    handleCancel () {
      this.close()
    },
    close () {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
